export const Color = {
    WHITE: '#fff',
    DARK: '#151a1d',
    GREEN: '#3cb46e',
}
